// Small, deterministic classification shared by the Hoy form and neural executor.
// A classification is a label, never evidence of a duration or a completed task.
const clean = value => String(value ?? '').trim().slice(0,120);
export const foldOwnerCategory = value => clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
const aliases = [
  ['WebProfit', ['webprofit','web profit','wp','owner','erp webprofit']],
  ['Memorial', ['memorial']],
  ['BeBlis', ['beblis','be blis']],
  ['Tu Razón', ['tu razon','turazon']],
  ['Seguimiento', ['seguimiento','seguimientos']],
  ['Salud', ['salud','gimnasio','entrenamiento','medico']],
  ['Casa', ['casa','limpieza','cocinar','cocine','ordenar la casa']],
  ['Hobbies', ['hobbies','hobby','videojuego','pintar por hobby']],
];
const containsPhrase = (haystack,needle) => (` ${haystack} `).includes(` ${needle} `);
export function suggestOwnerActivityCategory({title='',category='',projectName='',projects=[]}={}) {
  if(clean(category))return {category:clean(category),source:'explicit'};
  if(clean(projectName))return {category:clean(projectName),source:'project'};
  const phrase=foldOwnerCategory(title);
  if(!phrase)return {category:'',source:'missing'};
  const options=(Array.isArray(projects)?projects:[]).filter(p=>clean(p?.name)).map(p=>({name:clean(p.name),key:foldOwnerCategory(p.name)}))
    .filter(p=>p.key.length>2&&containsPhrase(phrase,p.key)).sort((a,b)=>b.key.length-a.key.length);
  if(options.length && (options.length===1||options[0].key.length>options[1].key.length))return {category:options[0].name,source:'linked_project'};
  const matches=aliases.filter(([,terms])=>terms.some(term=>containsPhrase(phrase,foldOwnerCategory(term))));
  if(matches.length===1)return {category:matches[0][0],source:'title'};
  return {category:'',source:matches.length>1?'ambiguous':'missing'};
}
export function ownerCategoryArea(value,fallback='other') {
  const key=foldOwnerCategory(value);
  if(key==='salud')return 'health';if(key==='casa')return 'home';if(key==='seguimiento')return 'people';
  if(key==='hobbies'||key==='personal')return 'personal';if(key==='comidas')return 'food';
  if(['webprofit','memorial','beblis','tu razon'].includes(key))return 'work';
  return fallback;
}
